import { Fragment } from 'react'

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** Wraps case-insensitive matches of `query` in `<mark>` for universal search snippets. */
export const highlightSearchQueryInPlainText = (text: string, query: string) => {
  const trimmed = query.trim()
  if (!trimmed) {
    return text
  }
  try {
    const re = new RegExp(`(${escapeRegExp(trimmed)})`, 'gi')
    const parts = text.split(re)
    return parts.map((part, idx) =>
      part.toLowerCase() === trimmed.toLowerCase() ? (
        <mark key={idx} className="rounded-sm bg-yellow-100 px-0.5">
          {part}
        </mark>
      ) : (
        <Fragment key={idx}>{part}</Fragment>
      )
    )
  } catch {
    return text
  }
}
